import { FunctionComponent, memo } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Game as GameType } from '~types';
import Currency from '~components/Currency';
import { Price } from '~ui/index';
import dayjs from 'dayjs';
import Time from '~frontend/components/header/live/Time';
import { useConfig } from '~components/hooks';

interface Props {
  getGame: GameType;
}

export const Drop: FunctionComponent<Props> = memo(
  ({ getGame: { getItem, getUser, price, createdAt, chance } }) => {
    const { t } = useTranslation();
    const getConfig = useConfig();

    return (
      <div
        className="top-drop-item status-1"
        data-rar={getItem.color}
        data-audio="5.wav"
        data-volume="0.4"
      >
        <div className="in-case-cost">
          {getConfig.isEU ? (
            <>
              <Currency />
              <Price sum={price} />
            </>
          ) : (
            <>
              <Price sum={price} />
              <Currency />
            </>
          )}
        </div>
        {chance && <div className="drop-chance">{chance}%</div>}
        {getItem.isStatTrak && (
          <div className="stattrack">
            <span className="fas fa-star" /> StatTrak™
          </div>
        )}
        <div className="top-drop-item-first"></div>
        <div className="honey"></div>
        <div className="drop-img">
          <img src={`${getItem.getImage}/200x200`} alt={getItem.getName} />
        </div>

        <div className="top-drop-item-hover">
          <div className="top-drop-item-ago">
            <Time createdAt={createdAt} />
          </div>
          <div className="top-drop-item-name">{getItem?.getName}</div>

          <Link to={`/user/${getUser.id}`} className="top-drop-item-ava">
            <img
              className="ava"
              src={getUser?.avatar}
              alt={getUser?.userName}
            />
            <div className="tooltip-block">{t('To the profile')}</div>
          </Link>
        </div>
      </div>
    );
  },
);
